import { render, staticRenderFns } from "./productadd.vue?vue&type=template&id=40bc511e&scoped=true&"
import script from "./productadd.vue?vue&type=script&lang=js&"
export * from "./productadd.vue?vue&type=script&lang=js&"
import style0 from "./productadd.vue?vue&type=style&index=0&id=40bc511e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40bc511e",
  null
  
)

export default component.exports